import { useEffect } from 'react';
import { useWatchableValue } from '@cotera/client/v0/actions/framework';
import type { WorkflowModel } from '../workflow.model';
import { useAgentTitleById } from './use-upstream-source-labels';

/**
 * Finishes the legacy binding-source heal that hydration starts.
 *
 * Loading the graph repairs refs whose source is a name the graph itself
 * derives (`Agent 3946c56f…`, a tool's key, a humanized type). A ref that used
 * an agent's *title* can only be matched once the agent list has loaded, which
 * is what this hook waits for. Both passes are idempotent, so re-running on
 * every graph change costs nothing on a healthy workflow.
 */
export function useHealLegacyBindingSources(model: WorkflowModel): void {
  const agentTitleById = useAgentTitleById();
  const graph = useWatchableValue(model.graphWatchable);

  useEffect(() => {
    if (graph === null || agentTitleById.size === 0) {
      return;
    }
    model.healLegacyBindingSources(agentTitleById);
  }, [model, graph, agentTitleById]);
}
